import { render, staticRenderFns } from "./test-record-info.vue?vue&type=template&id=c777e1f4&"
import script from "./test-record-info.vue?vue&type=script&lang=js&"
export * from "./test-record-info.vue?vue&type=script&lang=js&"
import style0 from "./test-record-info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c777e1f4')) {
      api.createRecord('c777e1f4', component.options)
    } else {
      api.reload('c777e1f4', component.options)
    }
    module.hot.accept("./test-record-info.vue?vue&type=template&id=c777e1f4&", function () {
      api.rerender('c777e1f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/test-record/test-record-info.vue"
export default component.exports